<template>
  <div class="object-mapper">
    <div
      v-for="(element, index) in getSchema"
      :key="element.id + '--' + index"
      class="database-form"
    >
      <div class="input-attributes">
        <label>{{ element.label }} </label>
        <input
          type="text"
          v-model="outputObject[element.name]"
          :disabled="isOperationTypeRead"
        />
        <div v-if="getDropdownItems.length" class="custom-dropdown">
          <generalDropdown :disabled="isOperationTypeRead">
            <template v-slot:optionData>
              <b-dropdown-item
                v-for="item in getDropdownItems"
                :key="item.label"
                @click="onOptionSelect(item, element.name)"
              >
                {{ item }}
              </b-dropdown-item>
            </template>
          </generalDropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralDropdown from '../core/general-dropdown.vue';

export default {
  name: 'objectMapper',
  data() {
    return {
      outputObject: {},
      disabledElement: [''],
    };
  },
  props: {
    databaseSchema: {
      type: String,
      default: null,
    },
    operationType: {
      type: String,
      default: null,
    },
    defaultItems: {
      type: Object,
      default: () => ({}),
    },
    task: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    isElementIsRadioORCheckbox(elementType) {
      return elementType === 'radio' || elementType === 'checkbox';
    },
    filteredOutElements(databaseSchema) {
      const disabledElementType = [
        'image',
        'video',
        'html',
        'title',
        'description',
        'horizontalrule',
        'togglelist',
        'wrapper',
        'divwrapper',
      ];
      this.outputObject = this.defaultItems;
      return JSON.parse(databaseSchema).filter(
        (schema) => !disabledElementType.includes(schema.type)
      );
    },
    filteredOutEmptyValues(object) {
      return Object.entries(object).reduce(
        (acc, [key, value]) => (value ? ((acc[key] = value), acc) : acc),
        {}
      );
    },
    onOptionSelect(itemName, elementName) {
      const selectedInput = this.task.input.find(
        (input) => input.label === itemName
      );
      this.outputObject[elementName] = selectedInput.name;
      this.$forceUpdate();
    },
  },
  computed: {
    getSchema() {
      return this.filteredOutElements(this.databaseSchema);
    },
    isOperationTypeRead() {
      return this.operationType === 'read';
    },
    getOutputJson() {
      return this.filteredOutEmptyValues(this.outputObject);
    },
    getDropdownItems() {
      if (this.task.input)
        return [...this.task.input]
          .map((item) => item.label)
          .filter((item) => item !== 'codelosSettings');
      return [];
    },
  },
  watch: {
    outputObject: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit('onInputChange', val);
      },
    },
  },
  components: {
    GeneralDropdown,
  },
};
</script>

<style scoped>
.database-form .input-attributes {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.database-form .input-attributes label {
  width: 250px;
  display: block;
  text-align: left;
  padding-right: 15px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.database-form .input-attributes input {
  width: calc(100% - 250px);
  border: 1px solid #dee3e9;
  border-radius: 0.375rem;
  padding: 10px 15px;
  cursor: text;
  height: auto;
}

.selection-type-input-wrap .selection-type-input {
  display: flex;
  align-items: center;
  width: calc(100% - 250px);
  flex-wrap: wrap;
}

.selection-type-input-wrap {
  display: flex;
  align-items: center;
  align-items: flex-start;
  margin-bottom: 14px;
}

.selection-type-input-wrap .selection-title {
  width: 250px;
  font-size: 14px;
  text-align: right;
  padding-right: 15px;
  position: relative;
  top: 2px;
}

.selection-type-input-wrap .selection-type-input > div {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.selection-type-input-wrap .selection-type-input > div input {
  width: 0;
  opacity: 0;
}

.selection-type-input-wrap .selection-type-input > div label {
  position: relative;
  padding-left: 20px;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}

.selection-type-input-wrap .selection-type-input > div label:before {
  content: '';
  position: absolute;

  left: 0px;
  top: 2px;
  width: 10px;
  height: 10px;
  border: 2px solid #4aae9b;
}

.selection-type-input-wrap
  .selection-type-input
  > div
  input[type='radio']
  + label:before {
  border-radius: 50%;
}

.selection-type-input-wrap
  .selection-type-input
  > div
  input[type='radio']:checked
  + label:after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: #4aae9b;
  left: 4px;
  top: 6px;
  border-radius: 50%;
}
.selection-type-input-wrap
  .selection-type-input
  > div
  input[type='checkbox']:checked
  + label:after {
  content: '';
  position: absolute;
  width: 6px;
  height: 2px;
  border: 2px solid;
  border-color: transparent transparent #4aae9b #4aae9b;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 4px;
  left: 2px;
}
.object-mapper {
  height: 100%;
  overflow-y: auto;
}

.down-arrow-icon {
  margin: 5px;
}
.down-arrow-icon img {
  width: 20px;
  height: 20px;
  transform: rotate(270deg);
}

.custom-dropdown ul {
  position: absolute;
  padding: 0;
  background: #fff;
  list-style: none;
  width: 130px;
  margin: 5px auto 0;
  left: 10px;
  top: 30px;
  color: #333;
  border: 1px solid #dbdbdb;
  text-align: initial;
  border-radius: 4px 4px 4px 4px;
  z-index: 1;
}
.database-form .input-attributes input:focus {
  outline: none;
}
</style>
